import React from 'react';
import { GlobeIcon, LanguagesIcon, ShoppingBasketIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const reasons = [{
  icon: LanguagesIcon,
  title: 'Español neutro',
  text: "Escrito sin regionalismos!"
}, {
  icon: ShoppingBasketIcon,
  title: 'Alimentos disponibles',
  text: 'Verduras, proteínas y carbohidratos que conseguís en toda LATAM y España.'
}, {
  icon: GlobeIcon,
  title: 'Estructuras universales',
  text: 'Los principios y protocolos funcionan aunque tu supermercado sea distinto.'
}];
export function WhyGlobal() {
  return <section className="bg-white py-20 sm:py-24" aria-labelledby="global-title" data-id="element-242" data-mp="3biqtgvv25hn7">
      <div className="mx-auto max-w-6xl px-6" data-id="element-243" data-mp="3gc24l96wkkkx">
        <div className="rounded-3xl bg-mint-800 px-8 py-12 sm:px-14 sm:py-16" data-id="element-244" data-mp="3lade1itact2m">
          <Reveal className="max-w-2xl" data-id="element-245" data-mp="3lchfzv7mji09">
            <h2 id="global-title" className="font-display text-3xl leading-tight text-white sm:text-4xl" data-id="element-246" data-mp="3qarcc9534ong">
              ¿Por qué funciona en cualquier país hispanohablante?
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-mint-100" data-id="element-247" data-mp="2d3pxi0um3nd9">
              Este material fue creado para vos, dondequiera que estés.
            </p>
          </Reveal>

          <dl className="mt-12 grid gap-10 sm:grid-cols-3" data-id="element-248" data-mp="2350da1f8tqtu">
            {reasons.map((reason, index) => <Reveal key={reason.title} delay={index * 0.05} data-id="element-249" data-mp="1y66zs8zyhzto" data-mpi={index}>
                <dt className="flex items-center gap-3 text-white" data-id="element-250" data-mp="1y7qis7czyoz5">
                  <reason.icon className="h-5 w-5 text-mint-300" aria-hidden="true" data-id="element-251" data-mp="2vu7e57266si9" />
                  <span className="font-display text-xl" data-id="element-252" data-mp="2qub8729wwr02">{reason.title}</span>
                </dt>
                <dd className="mt-3 text-[15px] leading-relaxed text-mint-100" data-id="element-253" data-mp="2m3md7cz0xbw6">
                  {reason.text}
                </dd>
              </Reveal>)}
          </dl>
        </div>
      </div>
    </section>;
}